<div class=" max-w-5xl ">
  <h2 class="text-2xl font-bold mb-6">Content Editor</h2>

  <!-- Section Selector -->
  <div class="mb-4">
    <label class="block text-sm font-medium mb-2">
      Select Section
    </label>

    <select
      [(ngModel)]="selectedOption"
      (change)="onSectionChange()"
      class="select select-bordered w-full max-w-xs"
    >
      <option value="about-us">About Us</option>
      <option value="privacy-policy">Privacy Policy</option>
    </select>
  </div>

  <!-- Editor -->
  <div class="mb-6">
    <label class="block text-sm font-medium mb-2">
      Content
    </label>

    <ckeditor
      [editor]="Editor"
      [(ngModel)]="currentContent"
      [config]="editorConfig"
      class="border rounded"
    >
    </ckeditor>
  </div>

  <!-- Actions -->
  <div class="flex gap-3">
    <button class="btn btn-primary" (click)="saveContent()">
      {{ isSaving ? 'Saving...' : 'Save' }}
    </button>

    <button class="btn btn-outline" (click)="resetContent()">
      Reset
    </button>
  </div>
</div>
